module.exports = __webpack_public_path__ + "static/media/photo-9.bd30bcd9.avif";